export default {
  headerContent: {
    title: 'Generali Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası yurt dışında olası tedavi masraflarını karşılayan sigorta çeşididir. 30.000 Euro teminatlı seyahat sağlık poliçenizi Generali Sigorta’dan yaptırarak avantajlı güvence hizmetlerinden yararlanabilirsiniz.',
        '30.000 Euro teminatlı seyahat sağlık sigortası vize almak için zorunludur. Bu poliçe Schengen vizesi ve ABD seyahatlerinde de geçerlidir.',
        'Generali Seyahatim Güvende Sağlık Sigortası planı sunmuş olduğu hizmetler ile sigortalılarına birçok avantaj sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Ayakta, Yatarak (Hastanede) Tıbbi Tedavi ',
            'Cenaze Nakli -',
            'Sigortalının Tıbbi Nedenlerle Nakli veya Seyahati',
            'Tıbbi Bilgi Ve Danışma',
            'Refakatçi Nakli',
            'Gerekli İlaçların Sevki',
            'Acil Mesajların İletilmesi',
            'Tıbbi Seyahat Bilgi Hattı'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle:
    'Generali Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Zorunlu Mu? ',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası vize istenen ülkelere yapılacak olan yolculuklar kapsamında vize alımı için zorunlu bir poliçedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortasını yurt dışına veya yurt içinde seyahat etmek isteyen bireyler yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Sağlık Sigortası Poliçesinde Yaş Sınırı Var Mı?',
      content: [
        {
          paragraph:
            '18 yaş ve üzeri olan kişiler yurtiçi ve yurt dışı seyahat sağlık sigortası yaptırabilirler. Fakat 18 yaşın altında olan çocuklar, 18 yaş üzeri sigorta ettiren herhangi bir yakını ile yurtiçi ve yurt dışı seyahat sağlık sigortasına dâhil olabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Sağlık Sigortası İçin Gerekli Belgeler Nelerdir? ',
      content: [
        {
          paragraph:
            'Seyahat edeceğiniz tarih, ülkeler ve T.C. kimlik numara bilgileriniz seyahat sağlık sigortası yaptırmak için gereklidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Sağlık Sigortası Ne Zaman Başlar Ve Biter?',
      content: [
        {
          paragraph:
            'Yurt dışına gerçekleşen seyahatler için sigorta poliçeniz ülkemiz sınırlarından çıkıldığının pasaportla tespit edildiği an başlar, ülkemiz sınırlarına girildiğinin pasaportla tespit edildiği an sona erer. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Ne Zaman Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası seyahat başlamadan önce yapılmalıdır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Durumunda Seyahat Sağlık Sigortasını Yanımda Taşımalı Mıyım?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortanızı poliçe olarak taşımanıza gerek yoktur. Telefonunuzda veya mailinizde bulundurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahatiniz başlamadan önce poliçenizi almanız gerekmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Vize istenen ülkelerde vize için gerekli belgeler arasında Seyahat sağlık sigorta poliçesi yer almaktadır. Bu sigortanın süresi ise yurt dışına yapılan seyahatler için ülkemiz sınırlarından çıkıldığının pasaportla tespit edildiği an başlar, ülkemiz sınırlarına girildiğinin pasaportla tespit edildiği an sona erer. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Vize Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Vize sağlık sigortası, yurt dışında kazaen karşılaşabileceğiniz yaralanma veya hastalanma sonucu tedavi masraflarınızı güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Vize İçin Seyahat Sağlık Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Vize için seyahat sağlık sigortası almak için ofisimizden alabileceğiniz gibi online olarak alokasko.com üzerinden de alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Yapmanız gereken uzman ekibimize sadece bilgilerinizi iletmek vermiş olduğunu bilgiler doğrultusunda uzman ekibimiz sizim için en uygun sigortayı araştırıp size sunacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Kaç Gün Geçerlidir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalının talebine göre yapılmaktadır. En az 3 gün olarak düzenlene bilen bu sigorta 1 yıllık da düzenlenebilmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Havaalanında Bagajlarım Kaybolursa veya Zarar Görürse Poliçem Zararımı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Check-in işlemiş yapılmış olan bagajınızın kaybolması, çalınması veya zarar görmesi halinde 400 EURO’ya kadar karşılanmaktadır. Yalnız havalimanı tarafından kayıp süresi içerisinde bulunamaması ve havayolu tarafından kayıp raporu düzenlenmiş olması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Kaza ve Hastalık Durumlarında Generali Sigorta Seyahat Sağlık Sigortası Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Kaza veya hastalık durumunda yapmanız gereken sadece anlaşmalı hastaneye gidip seyahat sağlık sigortanızınız olduğunu bildirmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Bildirmeniz sonucunda gerekli tedavi ve tetkiklerden poliçe limitleri dahilinde yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Sağlık Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası hesaplaması seyahat edilecek ülke bilgileri, seyahat süresi ve sigortalanmak isteyen kişinin bilgileri doğrultusunda hesaplanmaktadır. Bu bilgiler şirketlere iletilerek sizin için en uygun sigorta teklifi hazırlanmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Prim Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sigortanızın ödemesini kredi kartınızdan veya nakit olarak yapabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Online Seyahat Sağlık Sigortası Almak Avantajlı Mı?',
      content: [
        {
          paragraph: 'Online seyahat sigortası ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası iptali poliçe başlamadan en geç bir gün önce yapılabilmektedir. Poliçe başlamadan önce sigortanızı satın almış olduğunuz danışmanı arayarak iptal talebinde bulunabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Seyahat Sağlık Sigortası Ücretleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalı bilgileri, poliçe kapsamına, seyahat ülkesine ve seyahat süresine göre belirlenmektedir.',
          subList: null
        }
      ]
    }
  ]
}
